'use client';
import React, { useState, useEffect } from 'react';
import {
	Button,
	Typography,
	Col,
	Row,
	Input,
	Modal,
	Form,
	Select,
	Spin,
	notification,
	InputNumber
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import _, { truncate } from 'lodash';
import { InputDate, ProvinceSelector } from 'afrodita';
import TextArea from 'antd/lib/input/TextArea';
import { ContactBookIcon, Home10Icon, House03Icon } from 'hugeicons-react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import env from '../../../../../../environment';
import authClient from '../../../../../../Auth/Auth';

const { Text } = Typography;
const { Option } = Select;

const TableKutxaBank = ({ bankRequestId, mortgageId, mortgage, type }) => {
	const brand = process.env.NEXT_PUBLIC_BRAND;
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const [visibleCancel, setVisibleCancel] = useState<any>(false);
	const [provinces, setProvinces] = useState<any>(undefined);
	const [municipes, setMunicipes] = useState<any>(undefined);
	const [otherDatasAll, setOtherDatasAll] = useState<any>(undefined);
	const [data, setData] = useState<any>([]);
	const [loading, setLoading] = useState<any>(false);
	const [value, setValue] = useState<any>(undefined);
	let timeout;
	let currentValue;
	const params = useParams();
	const [emptyFields, setEmptyFields] = useState<any>([]);
	const [bankRequest, setBankRequest] = useState<any>(undefined);
	const [documentsTypes, setDocumentsTypes] = useState<any>(undefined);
	const numberParticipants = parseInt(mortgage?.mortgage?.participants) || 1;

	useEffect(() => {
		getBankRequest();
		getProvinces();
	}, []);

	useEffect(() => {
		if (mortgage && provinces && otherDatasAll) {
			const values = form.getFieldsValue();
			const undefinedFields = Object.entries(values)
				.filter(
					([fieldName, value]) => value === undefined || value === '' || value === 'Fecha inválida'
				)
				.map(([fieldName]) => fieldName);
			setEmptyFields(undefinedFields);
		}
	}, [form, mortgage, provinces, otherDatasAll]);

	const getBankRequest = () => {
		axios
			.get(`${env.api.url}/banks/bank-request/find-by-id/${bankRequestId}`, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				setBankRequest(response.data.data);
			});
	};
	const handleFormChange = () => {
		const values = form.getFieldsValue();
		const undefinedFields = Object.entries(values)
			.filter(
				([fieldName, value]) => value === undefined || value === '' || value === 'Fecha inválida'
			)
			.map(([fieldName]) => fieldName);
		setEmptyFields(undefinedFields);
	};

	const getProvinces = () => {
		axios
			.get(`${env.api.url}/banks/kutxa/data/json`, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				setProvinces(response.data.data.provinces);
				setDocumentsTypes(response.data.data.documentType);
			});
	};

	const search = (value) => {
		if (timeout) {
			clearTimeout(timeout);
			timeout = null;
		}
		currentValue = value;

		const searchData = () => {
			axios.get(`${env.api.url}/banks/uci/data/municipes?search=${value}`).then((response) => {
				if (currentValue === value) {
					setData(response.data.data.municipes);
				}
			});
		};
		timeout = setTimeout(searchData, 300);
	};
	const handleSearch = (value) => {
		if (value) {
			search(value);
		} else {
			setData([]);
		}
	};
	{
		/* {municipes?.map((province) => (
                                        <Option key={province.CMUN} value={province.CMUN}>
                                            {province.name}
                                        </Option>
                                    ))} */
	}
	const options = data.map((d) => (
		<Option key={d.code} value={d.code}>
			{d.name}
		</Option>
	));

	const renderForm = () => {
		const arrayform: any = [];

		for (let index = 1; index <= numberParticipants; index++) {
			arrayform.push(
				<>
					<Row style={{ marginTop: index === 1 ? 24 : 16 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%' }}>
							<div style={{ display: 'flex', width: 70 }}>
								<Text
									style={{
										fontSize: 14,
										fontWeight: 600
									}}>
									{'Titular ' + index}
								</Text>
							</div>
							<div style={{ height: 1, width: '100%', background: '#212121', flexGrow: 1 }}></div>
						</div>
					</Row>
					<Row gutter={[32, 0]} style={{ marginTop: 16 }}>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'name' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Nombre`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Nombre" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'firstSurname' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Apellido 1`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Apellido 1" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'birthdate' + index}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text
										style={{
											fontSize: 10,
											fontWeight: 400
										}}>{`Fecha de nacimiento`}</Text>
								}>
								<InputDate
									type="date"
									style={{ width: '100%' }}
									// onChange={handleFormChange}
									placeholder="Fecha de nacimiento"
								/>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'idDocumentType' + index}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Tipo de documento'}</Text>}
								className={emptyFields.includes('nifType') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									onChange={handleFormChange}
									filterOption={(input, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									filterSort={(optionA, optionB) =>
										optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
									}
									placeholder="Seleccionar">
									{documentsTypes.map((data) => (
										<Option key={data.code} value={data.code}>
											{data.label}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'nif' + index}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Número de documento'}</Text>
								}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%' }} type="text" placeholder="Número de documento" />
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'phone' + index}
								label="Teléfono de contacto"
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%' }} type="text" placeholder="000 000 000" />
							</Form.Item>
						</Col>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'email' + index}
								label="Email de contacto"
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Input style={{ width: '100%' }} type="text" placeholder="Correo electrónico" />
							</Form.Item>
						</Col>
					</Row>
				</>
			);
		}

		return arrayform;
	};

	const onFinish = (values) => {
		setLoading(true);
		const obj = {
			bankRequestId: bankRequestId,
			postalCode: values.postalCode,
			localityDetails: values.localityDetails,
			province: values.province,
			provinceDetails: values.provinceDetails,
			impCompra: values.impCompra,
			impFinac: values.impFinac
		};

		const ownerData: any = [];

		for (let index = 1; index <= numberParticipants; index++) {
			ownerData.push({
				name: values['name' + index],
				firstSurname: values['firstSurname' + index],
				idDocumentType: parseInt(values['idDocumentType' + index]),
				nif: values['nif' + index],
				email: values['email' + index],
				phone: values['phone' + index],
				birthdate: moment(values['birthdate' + index], 'DD-MM-YYYY').format('YYYY-MM-DD')
			});
		}

		obj['ownerData'] = ownerData;

		axios
			.post(`${env.api.url}/banks/kutxa/create-request`, obj, {
				headers: {
					Authorization: `Bearer ${authClient.getToken()}`
				}
			})
			.then((response) => {
				if (response.data.success === false) {
					notification.error({
						className: 'error-notification-gibobs',
						message: 'Error',
						description: response.data.message
					});
					setLoading(false);
				} else {
					notification.success({
						message: 'Operación realizada',
						description: 'La petición se ha enviado correctamente a Kutxabank'
					});
					setLoading(false);
					navigate(`/operations/mortgages/${mortgageId}/?tab=5`);
				}
			})
			.catch((response) => {
				setLoading(false);
			});
	};

	const cancelSend = () => {
		setVisibleCancel(!visibleCancel);
	};

	const handleCancel = () => {
		setVisibleCancel(!visibleCancel);
	};

	const handleOk2 = () => {
		setVisibleCancel(!visibleCancel);
		navigate(`/operations/mortgages/${mortgageId}/?tab=5`);
	};

	if (provinces && loading === false && documentsTypes) {
		return (
			<>
				<div style={{ marginTop: 24 }}>
					<Text className="primary-text" style={{ fontSize: 20, fontWeight: 600 }}>
						Envio a Kutxabank via API
					</Text>
				</div>
				<div
					style={{
						marginTop: 24,
						display: 'flex',
						background: '#EEEFF2',
						padding: 4,
						borderRadius: 4
					}}>
					<House03Icon size={24}></House03Icon>
					<Text className="primary-text" style={{ fontSize: 16, fontWeight: 400, marginLeft: 8 }}>
						Datos de la petición
					</Text>
				</div>
				<Form
					form={form}
					layout="vertical"
					name="sendMessageForm"
					className={`form-edit-data form-edit-data-${brand}`}
					initialValues={{
						province:
							type === 'subrogation'
								? mortgage?.subrogation.province === 'Lleida'
									? 'Lerida'
									: mortgage?.subrogation.province
								: mortgage?.propertyWishPurchase.province === 'Lleida'
								? 'Lerida'
								: mortgage?.propertyWishPurchase.province,

						impCompra:
							type === 'mortgage'
								? mortgage?.propertyWishPurchase?.maxBudget
								: mortgage?.subrogation?.maxBudget,
						impFinac:
							type === 'mortgage'
								? mortgage?.propertyWishPurchase?.mortgageAmount
								: mortgage?.subrogation?.amount,
						postalCode:
							type === 'mortgage'
								? mortgage?.propertyWishPurchase?.postalCode
								: mortgage?.subrogation?.postalCode,
						idDocumentType1: mortgage['owner1'].idDocumentType === 'ID' ? 5 : undefined,
						idDocumentType2: mortgage['owner2']?.idDocumentType === 'ID' ? 5 : undefined,
						name1: mortgage['owner1'].name,
						firstSurname1: mortgage['owner1'].firstSurname,
						birthdate1: moment(mortgage['owner1'].birthdate).format('DD-MM-YYYY'),
						nif1: mortgage['owner1'].nif,
						phone1: mortgage['owner1'].phone,
						email1: mortgage['owner1'].email,
						name2: mortgage['owner2']?.name,
						firstSurname2: mortgage['owner2']?.firstSurname,
						birthdate2: moment(mortgage['owner2']?.birthdate).format('DD-MM-YYYY'),
						nif2: mortgage['owner2']?.nif,
						phone2: mortgage['owner2']?.phone,
						email2: mortgage['owner2']?.email
					}}
					onChange={handleFormChange}
					onFinish={onFinish}>
					<Row gutter={[32, 0]} style={{ marginTop: 16 }}>
						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'impCompra'}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Precio de compra'}</Text>}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'impFinac'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>{'Importe de la hipoteca'}</Text>
								}>
								<InputNumber style={{ width: '100%', borderRadius: 4 }}></InputNumber>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'localityDetails'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text style={{ fontSize: 10, fontWeight: 400 }}>
										{`Descripción de la localidad`}
									</Text>
								}>
								<Select
									autoClearSearchValue={true}
									showSearch
									value={value !== '' ? value : ''}
									placeholder="Escribe para buscar..."
									defaultActiveFirstOption={false}
									showArrow={false}
									filterOption={false}
									onSearch={(value) => {
										handleSearch(value);
									}}
									notFoundContent={null}>
									{options}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'province'}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Provincia`}</Text>}
								className={emptyFields.includes('provinceBuy') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									showSearch
									// onChange={handleFormChange}
									filterOption={(input, option: any) =>
										option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									filterSort={(optionA, optionB) =>
										optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
									}
									placeholder="Seleccionar">
									{provinces.map((province) => (
										<Option key={province.codProvincia} value={province.codProvincia}>
											{province.description}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'provinceDetails'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={
									<Text
										style={{ fontSize: 10, fontWeight: 400 }}>{`Descripción de la provincia`}</Text>
								}>
								<Input style={{ width: '100%' }} placeholder="Breve descripción de la provincia" />
							</Form.Item>
						</Col>

						<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
							<Form.Item
								name={'postalCode'}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}
								label={<Text style={{ fontSize: 10, fontWeight: 400 }}>{`Código postal`}</Text>}>
								<Input style={{ width: '100%' }} placeholder="Código postal " />
							</Form.Item>
						</Col>
					</Row>
					<div
						style={{
							marginTop: 24,
							display: 'flex',
							background: '#EEEFF2',
							padding: 4,
							borderRadius: 4
						}}>
						<ContactBookIcon size={24}></ContactBookIcon>
						<Text className="primary-text" style={{ fontSize: 16, fontWeight: 400, marginLeft: 8 }}>
							Datos de los titulares
						</Text>
					</div>
					{renderForm()}

					<Row style={{ justifyContent: 'center', marginTop: 20 }}>
						<Button style={{ width: 96 }} onClick={() => cancelSend()}>
							Atras
						</Button>
						<Button style={{ marginLeft: 8, width: 96 }} type="primary" htmlType="submit">
							Aceptar
						</Button>
					</Row>
				</Form>
				<Modal
					className={`modal-common`}
					cancelButtonProps={{ style: { width: 96 } }}
					okButtonProps={{ style: { width: 96 } }}
					open={visibleCancel}
					title={<Text style={{ fontSize: '14px', fontWeight: '600px' }}>{'Cancelar envío'}</Text>}
					okText={'Aceptar'}
					cancelText={'Cancelar'}
					width={404}
					onCancel={handleCancel}
					onOk={handleOk2}>
					<Text style={{ fontSize: '12px', fontWeight: '400px' }}>
						{'¿¿Aceptas la cancelación del envío a Kutxabank?'}
					</Text>
				</Modal>
			</>
		);
	} else {
		return (
			<>
				<div style={{ textAlign: 'center', height: '40vh' }}>
					<Spin style={{ position: 'absolute', top: '30%' }} size="large" />
				</div>
				<div style={{ textAlign: 'center', height: '80vh' }}>
					<Text style={{ marginTop: 34, fontSize: 14, fontWeight: 500 }}>
						Por favor, no cierre ni recargue la pagina, puede tardar hasta 3 minutos...
					</Text>
				</div>
			</>
		);
	}
};
export default TableKutxaBank;
